import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import {useTranslation} from 'react-i18next';
import NewEmployeeFormComponent from '../NewEmployeeFormComponent';
import {isFormValid} from '../../../hooks/useEmployeeHandlers';
import type {NewEmployee} from '../../../types/employee';

interface AddNewEmployeeDialogProps {
    open: boolean;
    newEmployee: NewEmployee;
    onClose: () => void;
    onSubmit: () => void;
    handleFormChange: (field: keyof NewEmployee) => (event: any) => void;
    handleCheckboxChange: (field: keyof NewEmployee) => (event: any) => void;
    backendError?: { message: string; violations: string[] } | null;
}

const AddNewEmployeeDialog: React.FC<AddNewEmployeeDialogProps> = ({
                                                                       open,
                                                                       newEmployee,
                                                                       onClose,
                                                                       onSubmit,
                                                                       handleFormChange,
                                                                       handleCheckboxChange,
                                                                       backendError,
                                                                   }) => {
    const {t} = useTranslation();
    const [showAllErrors, setShowAllErrors] = React.useState(false);

    const handleSave = () => {
        if (!isFormValid(newEmployee)) {
            setShowAllErrors(true);
            return;
        }
        setShowAllErrors(false);
        onSubmit();
    };

    const handleClose = () => {
        setShowAllErrors(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={() => {
        }} disableEscapeKeyDown maxWidth="sm" fullWidth>
            <DialogTitle>{t('employee.dialog.addTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 2}}>
                    <NewEmployeeFormComponent
                        newEmployee={newEmployee}
                        handleFormChange={handleFormChange}
                        handleCheckboxChange={handleCheckboxChange}
                        showAllErrors={showAllErrors}
                        backendError={backendError}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    {t('common.actions.cancel')}
                </Button>
                <Button onClick={handleSave} variant="contained" color="primary" startIcon={<SaveIcon/>}>
                    {t('common.actions.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddNewEmployeeDialog;
